import Vue from "vue";
import VueRouter from "vue-router";
import packetRoute from "./packet";
import sdkhbRoute from "./sdkhb";
import kshbRoute from "./kshb";
import gameJumpRoute from "./gameJump";
import { SDKHB_APP_ID, SDKHB_CODE_BIND_APP_ID, SDKHB_WX_APP_ID } from "@/config";
import { initHostDisasterRecovery } from "@/libs/boxHost";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/index.vue"),
    children: [
      // 直播红包
      {
        path: "packet",
        name: "packet",
        component: () => import("../views/packet/index.vue"),
        meta: {
          title: "红包",
          name: "packet",
        },
        children: [
          {
            path: "/",
            name: "login",
            component: () => import("../views/packet/login.vue"),
            meta: {
              title: "红包",
              name: "packet",
            },
          },
          {
            path: "role",
            name: "role",
            component: () => import("../views/packet/role.vue"),
            meta: {
              title: "红包",
              name: "packet",
            },
          },
          {
            path: "get",
            name: "get",
            component: () => import("../views/packet/get.vue"),
            meta: {
              title: "红包",
              name: "packet",
            },
          },
        ],
      },
      // sdk红包
      {
        path: "sdkhb",
        name: "sdkhb",
        component: () => import("../views/sdkhb"),
        meta: {
          title: "红包提现",
          name: "sdkhb",
        },
        children: [
          {
            path: "login",
            name: "sdkhb-login",
            component: () => import("../views/sdkhb/login.vue"),
            meta: {
              title: "红包提现",
              name: "sdkhb",
              appId: SDKHB_APP_ID,
            },
          },
          {
            path: "wxLogin",
            name: "sdkhb-wxLogin",
            component: () => import("../views/sdkhb/login.vue"),
            meta: {
              title: "红包提现",
              name: "sdkhb",
              appId: SDKHB_WX_APP_ID,
            },
          },
          {
            path: "role",
            name: "sdkhb-role",
            component: () => import("../views/sdkhb/role.vue"),
            meta: {
              title: "红包提现",
              name: "sdkhb",
              appId: SDKHB_APP_ID,
            },
          },
          {
            path: "wxRole",
            name: "sdkhb-wxRole",
            component: () => import("../views/sdkhb/role.vue"),
            meta: {
              title: "红包提现",
              name: "sdkhb",
              appId: SDKHB_WX_APP_ID,
            },
          },
          {
            path: "code-bind",
            name: "sdkhb-codeBind",
            component: () => import("../views/sdkhb/codeBind.vue"),
            meta: {
              unAuth: true,
              title: "红包提现",
              appId: SDKHB_CODE_BIND_APP_ID,
            },
            beforeEnter: async (to, from, next) => {
              const { code } = to.query;
              if (!code) {
                const redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}`);
                localStorage.setItem('wxAuthQuery', JSON.stringify(to.query));
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${to.meta.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
              } else {
                next()
              }
            }
          },
          {
            path: "bind-test",
            name: "bind-test",
            component: () => import("../views/sdkhb/bindTest.vue"),
            meta: {
              unAuth: true,
              title: "红包提现",
              appId: SDKHB_WX_APP_ID,
            },
            beforeEnter: async (to, from, next) => {
              const { code } = to.query;
              if (!code) {
                const redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}`);
                localStorage.setItem('wxAuthQuery', JSON.stringify(to.query));
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${to.meta.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
              } else {
                next()
              }
            }
          },
        ],
      },
      // 快手红包
      {
        path: "kshb",
        name: "kshb",
        component: () => import("../views/kshb"),
        meta: {
          title: "快手红包",
          name: "kshb",
        },
        children: [
          {
            path: "login",
            name: "kshb-login",
            component: () => import("../views/kshb/login.vue"),
            meta: {
              title: "快手红包",
              name: "kshb",
            },
          },
          {
            path: "role",
            name: "kshb-role",
            component: () => import("../views/kshb/role.vue"),
            meta: {
              title: "快手红包",
              name: "kshb",
            },
          },
        ],
      },
      // 532召回活动
      {
        path: "recall/:type?",
        name: "recall",
        component: () => import("../views/recall"),
        meta: {
          title: "召回活动",
        },
      },
      {
        path: "recall-404",
        name: "recall-404",
        component: () => import("../views/recall/404.vue"),
        meta: {
          title: "活动维护中",
        },
      },
      // 微信小游戏转移包相关
      {
        path: "gameJump",
        name: "gameJump",
        component: () => import("../views/gameJump"),
        meta: {
          title: "游戏跳转",
          name: "gameJump",
        },
        children: [
          {
            path: "cdk",
            name: "gameJump-cdk",
            component: () => import("../views/gameJump/cdk.vue"),
            meta: {
              title: "兑换详情",
              name: "gameJump"
            },
          },
          {
            path: "invoiceCenter",
            name: "gameJump-invoiceCenter",
            component: () => import("../views/gameJump/invoiceCenter/index.vue"),
            meta: {
              title: "开票中心",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "invoiceCenter/result/:requestNo",
            name: "gameJump-invoiceCenter-result",
            component: () => import("../views/gameJump/invoiceCenter/result.vue"),
            meta: {
              title: "提交结果",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "invoiceCenter/records",
            name: "gameJump-invoiceCenter-records",
            component: () => import("../views/gameJump/invoiceCenter/records.vue"),
            meta: {
              title: "开票记录",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "invoiceCenter/records/:requestNo",
            name: "gameJump-invoiceCenter-detail",
            component: () => import("../views/gameJump/invoiceCenter/detail.vue"),
            meta: {
              title: "开票详情",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "bind",
            name: "gameJump-bind",
            component: () => import("../views/gameJump/bind.vue"),
            meta: {
              title: "绑定手机",
              name: "gameJump"
            },
          },
          {
            path: "pay-transfer",
            name: "gameJump-payTransfer",
            component: () => import("../views/gameJump/payTransfer.vue"),
            meta: {
              title: "游戏下载",

              name: "gameJump",
            },
          },
          {
            path: "oa-transfer",
            name: "gameJump-oaTransfer",
            component: () => import("../views/gameJump/oaTransfer.vue"),
            meta: {
              title: "关注公众号",
            },
            beforeEnter: async (to, from, next) => {
              const { code, oa_wx_app_id } = to.query;
              if (!code) {
                const redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}`);
                localStorage.setItem('wxAuthQuery', JSON.stringify(to.query));
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${oa_wx_app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
              } else {
                next()
              }
            }
          },
          {
            path: "vip-transfer",
            name: "gameJump-vipTransfer",
            component: () => import("../views/gameJump/vipTransfer.vue"),
            meta: {
              title: "vip",
              name: "gameJump",
            },
          },
          {
            path: "third-trans",
            name: "gameJump-thirdTrans",
            component: () => import("../views/gameJump/thirdTrans.vue"),
            meta: {
              title: "vip",
              name: "gameJump",
            },
          },
          
          {
            path: "qw-leads",
            name: "gameJump-qwLeads",
            component: () => import("../views/gameJump/qwLeads.vue"),
            meta: {
              title: "正在跳转中",
              name: "gameJump",
              unAuth: true
            },
          },
          {
            path: "zbqw-leads",
            name: "gameJump-zbqwLeads",
            component: () => import("../views/gameJump/zbqwLeads.vue"),
            meta: {
              title: "正在跳转中",
              name: "gameJump",
              unAuth: true
            },
          },
          {
            path: "general-qw-leads",
            name: "general-qw-leads",
            component: () => import("../views/gameJump/qwGeneralLeads.vue"),
            meta: {
              title: "正在跳转中",
              name: "gameJump",
              unAuth: true
            },
          },
          // 抖音企微专码
          {
            path: "douyin-qw-leads",
            name: "douyin-qw-leads",
            component: () => import("../views/gameJump/douyinQwLeads.vue"),
            meta: {
              title: "正在跳转中",
              name: "gameJump",
              unAuth: true
            },
          },
          {
            path: "general-qw-role-bind",
            name: "general-qw-role-bind",
            component: () => import("../views/gameJump/qwBinding.vue"),
            meta: {
              title: "信息确认",
              name: "gameJump",
              unAuth: true
            },
          },
          // VIP客服绑定
          {
            path: "vip-service",
            name: "gameJump-vipService",
            component: () => import("../views/gameJump/vipService.vue"),
            meta: {
              title: "游戏顾问",
              name: "gameJump",
              unAuth: true
            },
          },
          // 账号注销流程
          {
            path: "account-cancel",
            name: "gameJump-accountCancelLogin",
            component: () => import("../views/gameJump/accountCancel/login.vue"),
            meta: {
              title: "验证登录",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "account-cancel/notice",
            name: "gameJump-accountCancelNotice",
            component: () => import("../views/gameJump/accountCancel/notice.vue"),
            meta: {
              title: "账号注销",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "account-cancel/form",
            name: "gameJump-accountCancelForm",
            component: () => import("../views/gameJump/accountCancel/form.vue"),
            meta: {
              title: "账号注销",
              name: "gameJump",
              unAuth: true,
            },
          },
          {
            path: "account-cancel/success",
            name: "gameJump-accountCancelSuccess",
            component: () => import("../views/gameJump/accountCancel/success.vue"),
            meta: {
              title: "账号注销",
              name: "gameJump",
              unAuth: true,
            },
          },
        ],
      },
      // 盒子分享h5活动页 已经给出业务方，暂不收纳在/box下
      {
        path: "heziShare",
        name: "heziShare",
        component: () => import("../views/heziShare/index.vue"),
        meta: {
          title: "分享页面",
          name: "heziShare",
        },
        children: [
          {
            path: "act",
            name: "heziShare-act",
            component: () => import("../views/heziShare/act.vue"),
            meta: {
              title: "活动详情",
              name: "heziShare",
            },
          },
          {
            path: "game",
            name: "heziShare-game",
            component: () => import("../views/heziShare/game.vue"),
            meta: {
              title: "游戏详情",
              name: "heziShare",
            },
          },
          {
            path: "wxAct",
            name: "heziShare-wxAct",
            component: () => import("../views/heziShare/wxAct.vue"),
            meta: {
              title: "活动详情",
              name: "heziShare",
            },
          },
          {
            path: "wxGame",
            name: "heziShare-wxGame",
            component: () => import("../views/heziShare/wxGame.vue"),
            meta: {
              title: "游戏详情",
              name: "heziShare",
            },
          },
          {
            path: "share",
            name: "heziShare-share",
            component: () => import("../views/heziShare/share.vue"),
            meta: {
              title: "游戏详情",
              name: "heziShare",
            },
          },
        ],
      },
      // 盒子内嵌页
      {
        path: "box",
        name: "box",
        component: () => import("../views/box/index.vue"),
        children: [
          {
            path: "zillionaire",
            name: "box.zillionaire",
            component: () => import("../views/box/zillionaire"),
            meta: {
              title: "大富翁",
              name: "box.zillionaire",
              keepAlive: true,
            }
          },
          {
            path: "activeRegisterHome",
            name: "box.activeRegister.home",
            component: () => import("../views/box/activeRegister/index"),
            meta: {
              title: "注册活跃活动",
              name: "box.activeRegister.home",
              keepAlive: true,
            },
          },
          {
            path: "activeRegisterGame",
            name: "box.activeRegister.game",
            component: () => import("../views/box/activeRegister/game.vue"),
            meta: {
              title: "注册活跃活动",
              name: "box.activeRegister.game",
              keepAlive: true,
            },
          },
          {
            path: "jumpTo",
            name: "jumpTo",
            component: () => import("../views/box/jumpTo"),
            meta: {
              title: "跳转",
              name: "jumpTo",
            },
          },
          {
            path: "customJumpTo",
            name: "customJumpTo",
            component: () => import("../views/box/jumpTo/jumpCustom.vue"),
            meta: {
              title: "游戏盒子",
              name: "jumpCustom",
            },
          },
          {
            path: "qiweiGuide",
            name: "qiweiGuide",
            component: () => import("../views/box/qiwei/guide.vue"),
            meta: {
              title: "添加企微客服",
              name: "qiweiGuide",
            },
          },
          {
            path: "gameTesterHome",
            name: "box.gameTester.home",
            component: () => import("../views/box/btGameTester/home.vue"),
            meta: {
              title: "游戏体验官",
              name: "box.gameTester.home",
              keepAlive: true,
            },
          },
          {
            path: "gameTesterGame",
            name: "box.gameTester.game",
            component: () => import("../views/box/btGameTester/game.vue"),
            meta: {
              title: "游戏体验官",
              name: "box.gameTester.game",
              keepAlive: true,
            },
          },
          {
            path: "pkGame",
            name: "box.pkGame",
            component: () => import("../views/box/pkGame/index.vue"),
            meta: {
              title: "新注册游戏",
              name: "box.pkGame",
              keepAlive: true,
            },
          },
          {
            path: "328",
            name: "box.328",
            component: () => import("../views/box/328/index.vue"),
            meta: {
              title: "新注册游戏",
              name: "box.328",
              keepAlive: true,
            },
          },
          {
            path: "gameTransferHome",
            name: "box.gameTransfer.home",
            component: () => import("../views/box/gameTransfer/index.vue"),
            meta: {
              title: "多游戏转游",
              name: "box.gameTransfer.home",
              keepAlive: true,
            },
          },
          {
            path: "gameTransferGame",
            name: "box.gameTransfer.game",
            component: () => import("../views/box/gameTransfer/gift.vue"),
            meta: {
              title: "多游戏转游",
              name: "box.gameTransfer.game",
              keepAlive: true,
            },
          },
          // 交互demo测试页
          {
            path: "sign",
            name: "box.sign",
            meta: {
              title: "签到活动",
              name: "box.sign",
            },
            component: () => import("../views/box/sign.vue"),
          },
          // 转区
          {
            path: "server-transfer",
            name: "box.serverTransfer",
            meta: {
              title: "签到活动",
              name: "box.serverTransfer",
            },
            component: () => import("../views/box/serverTransfer.vue"),
          },
          // 权益中心
          {
            path: "vipPrivilegeCenter",
            name: "box.vipPrivilegeCenter",
            meta: {
              title: "VIP权益中心",
              name: "box.vipPrivilegeCenter",
              keepAlive: true,
            },
            component: () => import("../views/box/vipPrivilegeCenter"),
          },
          {
            path: "detail",
            name: "box.detail",
            meta: {
              title: "详情页",
              name: "box.detail",
            },
            component: () => import("../views/box/detail"),
          },
          // 玩心盒子-游戏预约
          {
            path: "gameSubscribe",
            name: "box.gameSubscribe",
            meta: {
              title: "游戏预约",
              name: "box.gameSubscribe",
              keepAlive: true,
            },
            component: () => import("../views/box/subscribe/gameSubscribe"),
          },
          {
            path: "gameRegister",
            name: "box.gameRegister",
            meta: {
              title: "游戏注册",
              name: "box.gameRegister",
              keepAlive: true,
            },
            component: () => import("../views/box/wxRegister"),
          },
          {
            path: "drawLottery",
            name: "box.drawLottery",
            meta: {
              title: "游戏注册",
              name: "box.drawLottery",
              keepAlive: true,
            },
            component: () => import("../views/box/wxDrawLottery"),
          },
          {
            path: "drawLotteryRecord",
            name: "box.drawLotteryRecord",
            meta: {
              title: "中奖记录",
              name: "box.drawLotteryRecord",
            },
            component: () => import("../views/box/wxDrawLottery/record.vue"),
          },
          // 公告列表
          {
            path: "noticeList",
            name: "box.noticeList",
            meta: {
              title: "公告列表",
              name: "box.noticeList",
              keepAlive: true,
            },
            component: () => import("../views/box/subscribe/noticeList"),
          },
          // 公告详情
          {
            path: "noticeDetail",
            name: "box.noticeDetail",
            meta: {
              title: "公告详情",
              name: "box.noticeDetail",
            },
            component: () => import("../views/box/subscribe/noticeDetail"),
          },
          // 活动专区
          {
            path: "actPlace",
            name: "box.actPlace",
            meta: {
              title: "新年打卡赢礼包",
              name: "box.actPlace",
              keepAlive: true,
            },
            component: () => import("../views/box/actPlace/actPlace"),
          },
          // 活动页面
          {
            path: "actPlaceDetail",
            name: "box.actPlaceDetail",
            meta: {
              title: "新年打卡赢礼包",
              name: "box.actPlaceDetail",
              // keepAlive: true,
            },
            component: () => import("../views/box/actPlace/actPlaceDetail"),
          },
          // 活动规则
          {
            path: "actPlaceRule",
            name: "box.actPlaceRule",
            meta: {
              title: "活动规则",
              name: "box.actPlaceRule",
            },
            component: () => import("../views/box/actPlace/actPlaceRule"),
          },
          // 领取记录
          {
            path: "actCollectionRecords",
            name: "box.actCollectionRecords",
            meta: {
              title: "领取记录",
              name: "box.actCollectionRecords",
            },
            component: () =>
              import("../views/box/actPlace/actCollectionRecords"),
          },
          {
            path: "customerService",
            name: "box.customerService",
            meta: {
              title: "联系客服",
              name: "box.customerService",
            },
            component: () => import("../views/box/actPlace/kefu"),
          },
          {
            path: "actGameDetail",
            name: "box.actGameDetail",
            meta: {
              title: "游戏详情",
              name: "box.actGameDetail",
            },
            component: () => import("../views/box/actPlace/gameDetail"),
          },
          // bt盒子 抽奖转盘内容
          {
            path: "btActPlace",
            name: "box.btActPlace",
            meta: {
              title: "千元礼包限时送",
              name: "box.btActPlace",
              keepAlive: true,
            },
            component: () => import("../views/box/btTurntable/btActPlace"),
          },
          {
            path: "btLuckyTurntable",
            name: "box.btLuckyTurntable",
            meta: {
              title: "千元礼包限时送",
              name: "box.btLuckyTurntable",
              keepAlive: true,
            },
            component: () =>
              import("../views/box/btTurntable/btLuckyTurntable"),
          },
          {
            path: "btActRule",
            name: "box.btActRule",
            meta: {
              title: "活动规则",
              name: "box.btActRule",
            },
            component: () => import("../views/box/btTurntable/btActRule"),
          },
          {
            path: "btActRecords",
            name: "box.btActRecords",
            meta: {
              title: "领取记录",
              name: "box.btActRecords",
            },
            component: () => import("../views/box/btTurntable/btActRecords"),
          },
          {
            path: "btGameDetail",
            name: "box.btGameDetail",
            meta: {
              title: "游戏详情",
              name: "box.btGameDetail",
            },
            component: () => import("../views/box/btTurntable/btGameDetail"),
          },
          // 玩心盒子转盘活动
          {
            path: "wxActPlace",
            name: "box.wxActPlace",
            meta: {
              title: "千元礼包限时送",
              name: "box.wxActPlace",
              keepAlive: true,
            },
            component: () => import("../views/box/wxTurntable/wxActPlace"),
          },
          {
            path: "wxLuckyTurntable",
            name: "box.wxLuckyTurntable",
            meta: {
              title: "千元礼包限时送",
              name: "box.wxLuckyTurntable",
              keepAlive: true,
            },
            component: () => import("../views/box/wxTurntable/wxLuckyTurntable"),
          },
          {
            path: "wxActRule",
            name: "box.wxActRule",
            meta: {
              title: "活动规则",
              name: "box.wxActRule"
            },
            component: () => import("../views/box/wxTurntable/wxActRule"),
          },
          {
            path: "wxActRecords",
            name: "box.wxActRecords",
            meta: {
              title: "领取记录",
              name: "box.wxActRecords"
            },
            component: () => import("../views/box/wxTurntable/wxActRecords"),
          },
          {
            path: "wxGameDetail",
            name: "box.wxGameDetail",
            meta: {
              title: "游戏详情",
              name: "box.wxGameDetail"
            },
            component: () => import("../views/box/wxTurntable/wxGameDetail"),
          },
          // 玩心盒子648活动
          {
            path: "makeProfitsAct",
            name: "box.makeProfitsAct",
            meta: {
              title: "648活动",
              name: "box.makeProfitsAct",
              keepAlive: true,
            },
            component: () => import("../views/box/makeProfitsAct"),
          },
          {
            path: "btActivityTemplate",
            name: "box.btActivityTemplate",
            meta: {
              title: "图文活动",
              name: "box.btActivityTemplate",
            },
            component: () => import("../views/box/btActivityTemplate"),
          },
          // 玩心盒子周活打卡活动会场
          {
            path: "weekSignInActPlace",
            name: "box.weekSignInActPlace",
            meta: {
              title: "攒能量活动会场",
              name: "box.weekSignInActPlace",
              keepAlive: true,
            },
            component: () => import("../views/box/weekSignInActPlace"),
          },

          // 玩心盒子周活打卡活动
          {
            path: "weekSignInAct",
            name: "box.weekSignInAct",
            meta: {
              title: "攒能量拿礼包",
              name: "box.weekSignInAct",
              // keepAlive: true,
            },
            component: () => import("../views/box/weekSignInActV2"),
          },

          // 玩心盒子新春福利
          {
            path: "rebateAct",
            name: "box.rebateAct",
            meta: {
              title: "玩心手游新春福利",
              name: "box.rebateAct",
            },
            component: () => import("../views/box/rebateAct"),
          },
          // bt盒子周打卡活动-会场
          {
            path: "btWeekSignInActPlace",
            name: "box.btWeekSignInActPlace",
            meta: {
              title: "周打卡活动",
              name: "box.btWeekSignInActPlace",
              keepAlive: true,
            },
            component: () => import("../views/box/btWeekSignIn/index"),
          },
          // bt盒子周打卡活动详情
          {
            path: "btWeekSignInAct",
            name: "box.btWeekSignInAct",
            meta: {
              title: "周打卡活动",
              name: "box.btWeekSignInAct",
              // keepAlive: true,
            },
            component: () => import("../views/box/btWeekSignIn/detail"),
          },
          // bt盒子领取记录
          {
            path: "btWeekSignInActRecord",
            name: "box.btWeekSignInAct.record",
            meta: {
              title: "领取记录",
              name: "box.btWeekSignInAct.record",
            },
            component: () => import("../views/box/btWeekSignIn/record"),
          },
          // 玩心盒子-自定义图文活动
          {
            path: "wxActivityTemplate",
            name: "box.wxActivityTemplate",
            meta: {
              title: "图文活动",
              name: "box.wxActivityTemplate",
            },
            component: () => import("../views/box/wxActivityTemplate/index.vue"),
          },
          // 玩心盒子-自定义图文活动-优算云云机引流
          {
            path: "wxCloudPromote",
            name: "box.wxCloudPromote",
            meta: {
              title: "图文活动",
              name: "box.wxCloudPromote",
            },
            component: () => import("../views/box/wxActivityTemplate/cloudPhone.vue"),
          },
          {
            path: "rebate2voucher",
            name: "box.rebate2voucher",
            meta: {
              title: "注册返利",
              name: "box.rebate2voucher",
              keepAlive: true,
            },
            component: () => import("../views/box/rebate2voucher"),
          },
          // 玩心盒子累计充值活动
          {
            path: "wxPayAmountActivity",
            name: "box.wxPayAmountActivity",
            meta: {
              title: "充值领豪礼",
              name: "box.wxPayAmountActivity",
              keepAlive: true,
            },
            component: () => import("../views/box/wxPayAmountActivity"),
          },
          // bt盒子累计充值活动 
          {
            path: "btPayAmountActivity",
            name: "box.btPayAmountActivity",
            meta: {
              title: "充值领豪礼",
              name: "box.btPayAmountActivity",
              keepAlive: true,
            },
            component: () => import("../views/box/btPayAmountActivity"),
          },
          // 安卓盒子拉新拉收活动 
          {
            path: "648",
            name: "box.648",
            meta: {
              title: "拉新",
              name: "box.648",
              keepAlive: true,
            },
            component: () => import("../views/box/648/index.vue"),
          },
          // bt盒子拉新拉收活动 
          {
            path: "btExpandUserActivity",
            name: "box.btExpandUserActivity",
            meta: {
              title: "拉新",
              name: "box.btExpandUserActivity",
              keepAlive: true,
            },
            component: () => import("../views/box/btExpandUserActivity/index.vue"),
          },
          {
            path: "wxWeekGiftActivity",
            name: "box.wxWeekGiftActivity",
            meta: {
              title: "礼包周周领",
              name: "box.wxWeekGiftActivity",
              keepAlive: true,
            },
            component: () => import("../views/box/wxWeekGiftActivity/index"),
          },
          {
            path: "wxWeekGiftActivityDetail",
            name: "box.wxWeekGiftActivityDetail",
            meta: {
              title: "礼包周周领",
              name: "box.wxWeekGiftActivityDetail",
              // keepAlive: true,
            },
            component: () => import("../views/box/wxWeekGiftActivity/detail"),
          },
          // 玩心盒子双重福利节活动
          {
            path: "wxDoubleWelfare",
            name: "box.wxDoubleWelfareActivity",
            meta: {
              title: "双重福利节",
              name: "box.wxDoubleWelfareActivity",
              keepAlive: true,
            },
            component: () => import("../views/box/wxDoubleWelfareActivity"),
          },
          // 玩心盒子夺宝活动
          {
            path: "winTreasure",
            name: "box.wxWinTreasures.index",
            meta: {
              title: "夺宝活动",
              name: "box.wxWinTreasures.index",
              keepAlive: true,
            },
            component: () => import("../views/box/wxWinTreasures/index"),
          },
          {
            path: "winTreasureDetail",
            name: "box.wxWinTreasures.detail",
            meta: {
              title: "夺宝活动",
              name: "box.wxWinTreasures.detail",
              keepAlive: true,
            },
            component: () => import("../views/box/wxWinTreasures/detail"),
          },
          {
            path: "winTreasureHistory",
            name: "box.wxWinTreasures.history",
            meta: {
              title: "历史夺宝榜单",
              name: "box.wxWinTreasures.history",
            },
            component: () => import("../views/box/wxWinTreasures/history"),
          },
           // bt盒子-游戏预约
           {
            path: "btGameSubscribe",
            name: "box.btGameSubscribe",
            meta: {
              title: "游戏预约",
              name: "box.btGameSubscribe",
              keepAlive: true,
            },
            component: () => import("../views/box/btSubscribe/gameSubscribe"),
          },
          // 公告列表
          {
            path: "btNoticeList",
            name: "box.btNoticeList",
            meta: {
              title: "公告列表",
              name: "box.btNoticeList",
            },
            component: () => import("../views/box/btSubscribe/noticeList"),
          },
          // 公告详情
          {
            path: "btNoticeDetail",
            name: "box.btNoticeDetail",
            meta: {
              title: "公告详情",
              name: "box.btNoticeDetail",
            },
            component: () => import("../views/box/btSubscribe/noticeDetail"),
          },
          {
            path: "gameStrategyCollect",
            name: "box.gameStrategyCollect",
            meta: {
              title: "收藏攻略",
              name: "box.gameStrategyCollect",
              keepAlive: true,
            },
            component: () => import("../views/box/gameStrategy/collect.vue"),
          },
          {
            path: "gameStrategyList",
            name: "box.gameStrategyList",
            meta: {
              title: "大神攻略",
              name: "box.gameStrategyList",
              keepAlive: true,
            },
            component: () => import("../views/box/gameStrategy/list.vue"),
          },
          {
            path: "gameStrategyDetail",
            name: "box.gameStrategyDetail",
            meta: {
              title: "大神攻略",
              name: "box.gameStrategyDetail",
            },
            component: () => import("../views/box/gameStrategy"),
          },
          {
            path: "accountClose",
            name: "box.accountClose",
            meta: {
              title: "注销账号",
              name: "box.accountClose",
            },
            component: () => import("../views/box/accountClose/index.vue"),
          },
          {
            path: "accountCloseNotice",
            name: "box.accountCloseNotice",
            meta: {
              title: "账号注销须知",
              name: "box.accountCloseNotice",
            },
            component: () => import("../views/box/accountClose/notice.vue"),
          },
        ],
      },
      // 代金券活动
      {
        path: "voucher",
        name: "voucher",
        meta: {
          title: "转盘活动",
          name: "voucher",
        },
        component: () => import("../views/voucher/index"),
      },
      // 2023.09.18 太古2少年歌行十一联名活动
      // {
      //   path: "tglm",
      //   name: "tglm",
      //   meta: {
      //     title: "太古2×少年歌行联名活动",
      //     name: "tglm",
      //   },
      //   component: () => import("../views/tg/index"),
      // },
      // {
      //   path: "tglm/act",
      //   name: "tglm.act",
      //   meta: {
      //     title: "太古2×少年歌行联名活动",
      //     name: "tglm.act",
      //   },
      //   component: () => import("../views/tg/act.vue"),
      // },
      {
        path: "tglm/fhAct",
        name: "tglm.fhAct",
        meta: {
          title: "太古2活动",
          name: "tglm.act",
        },
        component: () => import("../views/tg/cjAct.vue"),
      },
      // 太古2蛇年春节活动
      {
        path: "tglm/snAct",
        name: "tglm.snAct",
        meta: {
          title: "太古2活动",
          name: "tglm.act",
        },
        component: () => import("../views/tg/cjAct2.vue"),
      },
      // 快手表单活动
      {
        path: "ksForm",
        name: "ksForm",
        meta: {
          title: "快手表单",
          name: "ksForm",
        },
        component: () => import("../views/ksForm/index"),
        children: [
          {
            path: "ksActivity",
            name: "ksActivity",
            meta: {
              title: "抽奖活动",
              name: "ksActivity",
            },
            component: () => import("../views/ksForm/activity"),
            beforeEnter: async (to, from, next) => {
              if (from.name === 'ksActivityGift' || from.name === 'ksActivityGiftCode'|| from.name === 'ksActivityPayResult') {
                localStorage.setItem('ksFormActivityCheck', 'nochek')
              } else {
                localStorage.removeItem('ksFormActivityCheck')
              }
              next()
            }
          },
          {
            path: "ksActivityGift",
            name: "ksActivityGift",
            meta: {
              title: "选择礼包",
              name: "ksActivityGift",
            },
            component: () => import("../views/ksForm/gift"),
            beforeEnter: async (to, from, next) => {
              if (from.name === 'ksActivityGiftCode' || from.name === 'ksActivityGift'|| from.name === 'ksActivityPayResult') {
                localStorage.setItem('ksFormActivityCheck', 'nochek')
              } else {
                localStorage.removeItem('ksFormActivityCheck')
              }
              next()
            }
          },
          {
            path: "ksActivityGiftCode",
            name: "ksActivityGiftCode",
            meta: {
              title: "礼包码",
              name: "ksActivityGiftCode",
            },
            component: () => import("../views/ksForm/giftCode"),
          },
          {
            path: "ksActivityPayResult",
            name: "ksActivityPayResult",
            meta: {
              title: "支付结果",
              name: "ksActivityPayResult",
            },
            component: () => import("../views/ksForm/payResult"),
            beforeEnter: async (to, from, next) => {
              if (from.name === 'ksActivityGiftCode') {
                localStorage.setItem('ksFormActivityCheck', 'nochek')
              } else {
                localStorage.removeItem('ksFormActivityCheck')
              }
              next()
            }
          },
        ]
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 是否初始化过盒子域名防灾系统
let hasInitBoxHost = false

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  // 盒子路由匹配
  if (to.path.includes('/box/')) {
    if (!hasInitBoxHost) {
      hasInitBoxHost = true
      initHostDisasterRecovery()
    }
  }
  if (to.meta.name === "packet") {
    packetRoute(to, from, next);
    return;
  } else if (to.meta.name === "sdkhb") {
    sdkhbRoute(to, from, next);
    return;
  } else if (to.meta.name === "kshb") {
    kshbRoute(to, from, next);
    return;
  } else if (to.meta.name === "gameJump") {
    gameJumpRoute(to, from, next);
    return;
  } else if (to.meta.name === "box.detail") {
    document.title = to.params?.title || "详情页";
  }
  next();
});

export default router;
